/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, NgZone, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-specify-id-modal',
  template: `
    <form class="form-horizontal" role="form" #modalForm="ngForm" (ngSubmit)="checkId(modalForm)">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">Specify Your ID</h4>
      </div>
      <div class="modal-body">
        <p>Specify the ID for the new object below. We will check that it is unique before proceeding.</p>
        <p class="alert alert-danger" *ngIf="error">An object with the same ID has already been assigned. Choose another ID for your new object.</p>
        <div class="form-group" adnAdminFieldGroup>
          <label class="col-md-3 control-label">ID</label>
          <div class="col-md-9">
            <input #newIdModel="ngModel"
                   type="text"
                   maxlength="100"
                   pattern="^[a-z0-9-_]+$"
                   class="form-control"
                   name="newId"
                   [(ngModel)]="newId"
                   required>
            <adn-admin-field-validation [ngModelRef]="newIdModel"></adn-admin-field-validation>
            <div class="help-block" *ngIf="newIdModel.errors?.pattern">{{ 'validation.idFormat' | ogTranslate }}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default" [disabled]="modalForm.invalid">Specify ID</button>
      </div>
    </form>
  `
})
export class SpecifyIdModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  model: any;
  modelComms: any;

  newId = '';
  error = false;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly $state: StateService,
    private readonly ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.newId = this.model?.id || '';
  }

  checkId(form: NgForm): void {
    if (form.invalid || !this.model || !this.modelComms) {
      return;
    }

    this.error = false;
    this.modelComms.updateObjectId(this.model, this.newId, () => {
      this.ngZone.run(() => {
        this.error = true;
      });
    }, () => {
      this.ngZone.run(() => {
        this.bsModalRef.hide();
        this.$state.go(this.$state.current.name, {id: this.newId, isNew: true}, {
          notify: false,
          reload: false,
          location: 'replace'
        });
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
